export function getColorsProps(props) {
    var _a;
    if (props.grey === true)
        props.color = 'surface-7';
    if (props.purple === true)
        props.color = 'purple-7';
    if (props.lightGrey === true)
        props.color = 'surface-4';
    if (props.white === true)
        props.color = 'white';
    if (props.black === true)
        props.color = 'surface-9';
    if (props.blue === true)
        props.color = 'blue-7';
    if (props.red === true)
        props.color = 'red-7';
    if (props.green === true)
        props.color = 'green-7';
    if (props.orange === true)
        props.color = 'orange-5';
    if (props.primary === true)
        props.color = 'primary';
    if (props.secondary === true)
        props.color = 'secondary';
    if (props.hoverable)
        props.hoverColor = 'surface-2';
    if (typeof props.borderColor === 'string') {
        if (!props.borderColor.startsWith('border-'))
            props.borderColor = "border-".concat(props.borderColor);
    }
    if (props.borderGrey === true)
        props.borderColor = 'border-surface-7';
    if (props.borderPurple === true)
        props.borderColor = 'border-purple-7';
    if (props.borderLightGrey === true)
        props.borderColor = 'border-surface-4';
    if (props.borderWhite === true)
        props.borderColor = 'border-white';
    if (props.borderBlack === true)
        props.borderColor = 'border-surface-9';
    if (props.borderBlue === true)
        props.borderColor = 'border-blue-7';
    if (props.borderRed === true)
        props.borderColor = 'border-red-7';
    if (props.borderGreen === true)
        props.borderColor = 'border-green-7';
    if (typeof props.textColor === 'string') {
        if (!props.textColor.startsWith('text-'))
            props.textColor = "text-".concat(props.textColor);
    }
    if (props.textGrey === true)
        props.textColor = 'text-surface-7';
    if (props.textPurple === true)
        props.textColor = 'text-purple-7';
    if (props.textLightGrey === true)
        props.textColor = 'text-surface-4';
    if (props.textWhite === true)
        props.textColor = 'text-white';
    if (props.textBlack === true)
        props.textColor = 'text-surface-9';
    if (props.textBlue === true)
        props.textColor = 'text-blue-7';
    if (props.textRed === true)
        props.textColor = 'text-red-7';
    if (props.textGreen === true)
        props.textColor = 'text-green-7';
    if (typeof props.focusedBorderColor === 'string')
        props.focusedBorderColor = "focus-border-".concat(props.focusedBorderColor);
    if (typeof props.hoverBorderColor === 'string')
        props.hoverBorderColor = "hover-border-".concat(props.hoverBorderColor);
    if (typeof props.activedBorderColor === 'string')
        props.activedBorderColor = "active-".concat(props.activedBorderColor);
    if (typeof props.focusedTextColor === 'string')
        props.focusedTextColor = "focus-text-".concat(props.focusedTextColor);
    if (typeof props.hoverTextColor === 'string')
        props.hoverTextColor = "hover-text-".concat(props.hoverTextColor);
    if (typeof props.activedTextColor === 'string')
        props.activedTextColor = "active-text-".concat(props.activedTextColor);
    if (typeof props.focusedColor === 'string')
        props.focusedColor = "focus-".concat(props.focusedColor);
    if (typeof props.hoverColor === 'string')
        props.hoverColor = "hover-".concat(props.hoverColor);
    if (typeof props.activedColor === 'string')
        props.activedColor = "active-".concat(props.activedColor);
    var classes = (_a = {},
        _a[props.color] = typeof props.color === 'string',
        _a[props.textColor] = typeof props.textColor === 'string',
        _a[props.borderColor] = typeof props.borderColor === 'string',
        _a[props.focusedColor] = typeof props.focusedColor === 'string',
        _a[props.focusedColor] = typeof props.focusedColor === 'string',
        _a[props.focusedTextColor] = typeof props.focusedTextColor === 'string',
        _a[props.hoverColor] = typeof props.hoverColor === 'string',
        _a[props.hoverColor] = typeof props.hoverColor === 'string',
        _a[props.hoverTextColor] = typeof props.hoverTextColor === 'string',
        _a[props.focusedBorderColor] = typeof props.focusedBorderColor === 'string',
        _a[props.hoverBorderColor] = typeof props.hoverBorderColor === 'string',
        _a[props.activedBorderColor] = typeof props.activedBorderColor === 'string',
        _a[props.activedColor] = typeof props.activedColor === 'string',
        _a[props.activedTextColor] = typeof props.activedTextColor === 'string',
        _a);
    var styleToUse = {};
    if (typeof props.textColorCss === 'string')
        styleToUse.color = props.textColorCss;
    if (typeof props.backgroundColorCss === 'string')
        styleToUse.backgroundColor = props.backgroundColorCss;
    if (typeof props.borderColorCss === 'string')
        styleToUse.borderColor = props.borderColorCss;
    if (typeof props.opacity === 'string' || typeof props.opacity === 'number')
        styleToUse.opacity = props.opacity;
    if (typeof props.backgroundImage === 'string') {
        styleToUse.backgroundImage = "url(\"".concat(props.backgroundImage, "\")");
        styleToUse.backgroundRepeat = 'no-repeat';
        styleToUse.backgroundSize = "100%";
        delete props.backgroundImage;
    }
    return {
        classes: classes,
        props: {},
        styles: styleToUse,
        variables: {}
    };
}
export function setTextColor(props) {
    var _a, _b, _c;
    if (props.primary || props.secondary || props.accent || props.black || Number((_a = props.color) === null || _a === void 0 ? void 0 : _a.substring(((_b = props.color) === null || _b === void 0 ? void 0 : _b.length) - 1)) >= 5 || ((_c = props.color) === null || _c === void 0 ? void 0 : _c.endsWith('10'))) {
        props.textColor = 'white';
        props.hoverTextColor = 'surface-1';
        props.activedTextColor = 'white';
    }
}
